// The big host screen prop: a ~4 m framed display on two truss legs. Plain
// primitives for now — the owner may swap in a Blender GLB later (keep the
// screen face at SCREEN_Z / SCREEN_Y / SCREEN_W × SCREEN_H so the live
// content in TriviaScreen3D still lines up). Decoration only: not collidable.

import React from 'react';
import { SCREEN_H, SCREEN_W, SCREEN_Y, SCREEN_Z } from './triviaLayout';

const FRAME = '#15181d';
const TRUSS = '#2a2f36';
const TRIM = '#b8862e';
const deco = { collidable: false };

export function TriviaHostScreen() {
  const legX = SCREEN_W / 2 - 0.25;
  const bottom = SCREEN_Y - SCREEN_H / 2;
  return (
    <group>
      {/* Frame + black panel */}
      <mesh position={[0, SCREEN_Y, SCREEN_Z - 0.03]} castShadow userData={deco}>
        <boxGeometry args={[SCREEN_W + 0.22, SCREEN_H + 0.22, 0.12]} />
        <meshStandardMaterial color={FRAME} roughness={0.5} metalness={0.3} />
      </mesh>
      <mesh position={[0, SCREEN_Y, SCREEN_Z + 0.035]} userData={deco}>
        <planeGeometry args={[SCREEN_W, SCREEN_H]} />
        <meshBasicMaterial color="#05080d" toneMapped={false} />
      </mesh>
      {/* Gold trim along the bottom */}
      <mesh position={[0, bottom - 0.115, SCREEN_Z + 0.035]} userData={deco}>
        <boxGeometry args={[SCREEN_W + 0.22, 0.03, 0.02]} />
        <meshStandardMaterial color={TRIM} roughness={0.35} metalness={0.7} />
      </mesh>
      {/* Two legs with feet */}
      {[-legX, legX].map((x) => (
        <group key={x} position={[x, 0, SCREEN_Z - 0.06]}>
          <mesh position={[0, bottom / 2, 0]} castShadow userData={deco}>
            <boxGeometry args={[0.12, bottom, 0.12]} />
            <meshStandardMaterial color={TRUSS} roughness={0.6} metalness={0.5} />
          </mesh>
          <mesh position={[0, 0.03, 0.1]} castShadow receiveShadow userData={deco}>
            <boxGeometry args={[0.4, 0.06, 0.7]} />
            <meshStandardMaterial color={TRUSS} roughness={0.6} metalness={0.5} />
          </mesh>
        </group>
      ))}
    </group>
  );
}

export default TriviaHostScreen;
